import { ENV, SERVICES } from '@autopass-web/domain';

import type { ServiceType } from '@autopass-web/types';

interface CreditCard3dValidationOptions {
  serviceType: ServiceType;
  cardNumber: string;
  cardExpireDate: string;
  cardCvc: string;
  amount: string;
  merchantUid: string;
  orderType: string;
  transactionId?: string;
  transactionType: string;
  callbackUrl: string;
}

const ALPHA_PAYMENT_URL = 'https://payment-alpha.mochipay.xyz/webview';
const PROD_PAYMENT_URL = 'https://payment.mochipay.xyz/webview';

export const creditCard3dValidation = ({
  serviceType,
  cardNumber,
  cardExpireDate,
  cardCvc,
  amount,
  merchantUid,
  orderType,
  transactionId,
  transactionType,
  callbackUrl,
}: CreditCard3dValidationOptions) => {
  const PAYMENT_URL =
    ENV === 'development' ? ALPHA_PAYMENT_URL : PROD_PAYMENT_URL;

  const formActionUrl =
    serviceType === SERVICES.GUEST_ALPR
      ? `${PAYMENT_URL}/credit_card`
      : `${PAYMENT_URL}/credit_card/create_with_payment`;
  const form = document.createElement('form');
  form.method = 'post';
  form.action = formActionUrl;
  form.setAttribute('hidden', 'true');

  const inputGroup = [
    {
      name: 'pan',
      value: cardNumber.replace(/\s/g, ''),
    },
    {
      name: 'expire_date',
      value: cardExpireDate.replace(/\//g, ''),
    },
    {
      name: 'cvc',
      value: cardCvc,
    },
    {
      name: 'amount',
      value: amount,
    },
    {
      name: 'merchant_uid',
      value: merchantUid,
    },
    {
      name: 'order_type',
      value: orderType,
    },
    {
      name: 'transaction_id',
      value: transactionId,
    },
    {
      name: 'transaction_type',
      value: transactionType,
    },
    {
      name: 'frontend_callback_url',
      value: callbackUrl,
    },
  ];

  inputGroup.forEach((data) => {
    if (!data.value) return;

    const inputElement = document.createElement('input');
    inputElement.value = data.value;
    inputElement.name = data.name;
    form.appendChild(inputElement);
  });

  document.body.appendChild(form);

  form.submit();
};
